import React, { useEffect } from 'react';

import { StepProps, track } from '@betterment/js-runtime';
import { Icon, Text } from '@betterment/samba-react';
import { Box, Button, Heading } from '@betterment/style-closet-react';

import { CustomerSignupValues } from './Controller';

import { WorkflowLayout } from '../Shared/layout/WorkflowLayout';
import { urlBuilder } from '../Shared/urlBuilder';

interface Props extends StepProps<CustomerSignupValues> {
  handleClose: () => void;
}

const LimitError: React.FC<React.PropsWithChildren<Props>> = ({ flowState, handleClose }) => {
  useEffect(() => {
    track('ElementViewed', { name: 'CheckingOpeningMaxAttemptError', flow: 'OpenCheckingAccount' });
  }, []);
  const { stepTitle } = flowState.values;

  return (
    <WorkflowLayout
      feature="checking_customer_signup"
      pageTitle="Sign up - Checking"
      workflowTitle={stepTitle}
      onClose={handleClose}
    >
      <Box mb="8">
        <Icon name="ExclamationCircle" size="large" color="icon" />
      </Box>
      <Heading variant="primary" mb="8">
        We're unable to open Checking for you at this time
      </Heading>
      <Box mb="9">
        <Text as="p" css={{ marginBottom: 'space.200', _last: { marginBottom: 'space.0' } }}>
          It looks like there was an issue with opening your Checking account. We're sorry for the inconvenience.
        </Text>
      </Box>
      <a href={urlBuilder.appHome.absolute()}>
        <Button px="8">Close</Button>
      </a>
    </WorkflowLayout>
  );
};
export default LimitError;
